"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaMatrizCurricular = exports.yupMatrizCurricular = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../enums");
exports.yupMatrizCurricular = yup.object({
    nome: yup.string().default('').max(40).required().label('Descrição'),
    // localidade: yup.string().default('').max(40).required().label('Localidade'), // Não Utilizado
    anoImplantacao: yup.string().default('').max(4).required().label('Ano Implantação'),
    nre: yup.string().default('').max(30).required().label('NRE'),
    modulo: yup.number().default(0).label('Modulo'),
    duracao: yup.number().default(0).label('Duração'),
    horaAula: yup.number().default(0).label('Hora/Aula'),
    horaRelogio: yup.number().default(0).label('Horas Relógio'),
    implantacao: yup.string().default('').max(1).required().label('Implantação'),
    grau: yup
        .mixed()
        .oneOf(Object.values(enums_1.ECursoGrau))
        .required()
        .default(enums_1.ECursoGrau.Fundamental)
        .label('Nivel'),
    duracaoAula: yup.number().default(0).label('Duração Aulas'),
    leiCertificado: yup.string().default('').max(70).required().label('Lei Cert.'),
    serieInicial: yup.number().default(0).label('Série Inicial'),
    serieFinal: yup.number().default(0).label('Série Final'),
    // modelo: yup.string().default('').max(3).required().label('Modelo'), // Modelo de Documentação Oficial
    autorizacaoEstabelcimento: yup.string().default('').max(60).required().label('Autorização do Estabelecimento'),
    // recEstab: yup.string().default('').max(60).required().label('Reconhecimento do Estabelecimento'), // Não Utilizado
    reconhecimentoCurso: yup.string().default('').max(60).required().label('Reconhecimento do Curso'),
    renovacaoCurso: yup.string().default('').max(60).required().label('Renovação'),
    horasAjuste2: yup.number().default(0).label('Ajuste de Horas'),
    nomeCurso: yup.string().default('').max(146).required().label('Nome do Curso'),
    horasDia2: yup.string().default('').max(5).required().label('Total de Horas p/ Dia'),
    diasBimestre1: yup.number().default(0).label('Dias Letivos 1º Bimestre'),
    diasBimestre2: yup.number().default(0).label('Dias Letivos 2º Bimestre'),
    diasBimestre3: yup.number().default(0).label('Dias Letivos 3º Bimestre'),
    diasBimestre4: yup.number().default(0).label('Dias Letivos 4º Bimestre'),
    diasLetivo: yup.number().default(0).label('Dias Letivos Anual'),
    imprimirEspaco: yup.boolean().required().default(false).label('Imprimir Espaço Entre BNC e PD'),
    imprimirTodas: yup.boolean().required().default(false).label('Imprimir Todas Matérias'),
    turno: yup.number().default(0).integer().label('Turno'),
    sinteseAvaliacao: yup.string().default('').max(500).required().label('Sintese de Avaliação'),
});
exports.schemaMatrizCurricular = exports.yupMatrizCurricular.shape({});
